import React from 'react'

const LoadingView = ({ currentlySending }: { currentlySending: boolean }) => {
  return currentlySending ? <div> Loading... </div> : null
}

export default LoadingView
